/**
 * Main Layout Component
 * Provides navigation and header for all protected pages
 * @component Layout
 */

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { translate } from '../../locales';
import NavigationMenu from './NavigationMenu/NavigationMenu';
import HeaderMenu from './HeaderMenu';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  fullWidth?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, fullWidth = false }) => {
  const { user } = useAuth();
  const { language } = useLanguage();
  
  const t = (key: any) => translate(key, language as 'en' | 'ua');

  // Get business info from user data or use defaults
  const salonName = (user as any)?.businessName || t('navigation.salon.defaultName');

  return (
    <div className="master-layout">
      {/* Navigation Menu */}
      <NavigationMenu
        salonName={salonName}
        logoUrl={(user as any)?.logoUrl}
      />
      
      <div className="main-area">
        {/* Header Menu */}
        <HeaderMenu />
        
        {/* Main Content Area */}
        <main className="main-content">
          <div className={`content-wrapper ${fullWidth ? 'full-width' : ''}`}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
